import { zodResolver } from '@hookform/resolvers/zod';
import { getConditionalSchema } from '@pelicargo/utils';
import { useMemo, useRef } from 'react';
import { z } from 'zod';

import { trpc } from '../config/trpc';

//https://github.com/colinhacks/zod/issues/2909#issuecomment-3018173306
const extender = <Base extends z.AnyZodObject, Extended extends Record<string, z.ZodType>>(
  base: Base,
  extendWith: Extended,
) =>
  z.object({
    ...(base.shape as Base['shape']),
    ...extendWith,
  });

export const useConditionalResolver = <T extends z.AnyZodObject>(schema: T, quoteId: number) => {
  const { data: fields } = trpc.getConditionalFields.useQuery({
    id: quoteId,
  });
  const resolver = useRef<ReturnType<typeof zodResolver>>();

  return useMemo(() => {
    const extendedSchema = extender(schema, getConditionalSchema(fields));
    const extendedResolver = zodResolver(extendedSchema);

    resolver.current = extendedResolver;

    return {
      fields,
      // break the cache
      resolver: ((...args) => (resolver.current as typeof extendedResolver)(...args)) as typeof extendedResolver,
      schema: extendedSchema,
    };
  }, [fields, schema]);
};
